import debug from 'Helper/debugHelpers'

export class ApiException {
  constructor(name, status, data) {
    this.name = name
    this.status = status
    this.data = data
  }
}

export function jsonResponseHandler(response) {
  return response
    .clone()
    .json()
    .then(data => {
      if (!response.ok) {
        throw new ApiException('status-error', response.status, data)
      } else {
        return { data, status: response.status }
      }
    })
    .catch(err => genericErrorResponseHandler(response, err))
}

export function textResponseHandler(response) {
  return response
    .clone()
    .text()
    .then(data => {
      if (!response.ok) {
        throw new ApiException('status-error', response.status, data)
      } else {
        return { data, status: response.status }
      }
    })
    .catch(err => genericErrorResponseHandler(response, err))
}

function genericErrorResponseHandler(response, e) {
  if (e instanceof SyntaxError) {
    // if its a syntax error its almost certainly json parsing.
    response.text().then(text => {
      debug.logObject(
        'SyntaxError text:',
        text,
        debug.logLevels.API,
        'error'
      )
    })
    if (
      response.status !== 200 &&
      response.status !== 201 && // auth success
      response.status !== 202 && // accepted
      response.status !== 204 && // auth success
      response.status !== 302 && // redirect
      response.status !== 400 &&
      response.status !== 422 && // auth "validation"
      response.status !== 404 &&
      response.status !== 500 &&
      response.status !== 503 &&
      response.status !== 504
    ) {
      // re-throw the exception if its not a status code we know how to handle.
      throw e
    } else {
      throw new ApiException(
        'status-error',
        response.status,
        { error: 'json_parse_error' }
      )
    }
  } else {
    throw e
  }
}

export function blobResponseHandler(response) {
  if (!response.ok) {
    return response.json().then(data => {
      throw new ApiException('status-error', response.status, data)
    })
  }
  const content = response.headers.get('Content-Disposition')
  let filename
  if (content) {
    const arr = content.split(';')
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].includes('filename=')) {
        filename = arr[i].replace('filename=', '').trim()
      }
    }
  }
  return response.blob().then(data => {
    return { data, status: response.status, filename }
  })
}

export function errorResponseHandler(error) {
  if (error.name === 'status-error') {
    return { data: error.data, status: error.status }
  } else if(error.name !== 'AbortError' && error !== 'Canceled due to submission of updated api call') {
    // this is most likely a network error of some sort
    const message = typeof error === 'string' ? error.toLowerCase() : 'was aborted.'
    debug.log(`Call for resource ${resource} ${message}`, debug.logLevels.API)
  }
  throw error
}
